import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'perfil',
  templateUrl: 'perfil.html'
})
export class PerfilComponent implements OnChanges {

  @Input() backButton: boolean = false;
  @Input() isAdmin: boolean;
  @Input() ocupation: string = "";
  @Input() fullName: string = "";
  @Input() data: any;
  @Input() sbmMin: number;
  @Input() sbmMax: number;
  @Output() dataReturn: EventEmitter<any> = new EventEmitter<any>();
  @Output() realTime: EventEmitter<any> = new EventEmitter<any>();
  @Output() formBack: EventEmitter<void> = new EventEmitter<void>();
  @Input() validation = {
    edadJubilacion: { col1: 55, col2: 70 },
    edadIngreso: { col1: 16, col2: 0 },
    edadActual: { col1: 16, col2: 95 },
    antiguedad: { col1: 0, col2: 0 },
    miEsperanzaDeVida: { col1: 0, col2: 110, },
    esperanzaDeVidaGeneral: { col1: 0, col2: 110 },
    semanasCotizadas: 0,
    anoImss: { col1: 0, col2: 0 },
    sueldoMensual: { col1: 0, col2: 0 },
    sueldoDiario: 0,
    factorInteg: { col1: 1, col2: 2 },
    ingresoNeto: { col1: 0, col2: 1000000 },
    planJubilacion: 0,
    planEquivaleEnIL: { col1: 0, col2: 5 },
    ahorrasParaJubilarte: { col1: true, col2: false },
    ahorroIndividual: { col1: 0, col2: 10 },
    anosAhorrando: { col1: 0, col2: 0 },
    limiteMininoSueldo: 0
  }
  myForm: FormGroup;
  SbmMin: number = 0;
  SbmMax: number = 0;
  umaDiaria: number = 89.62;
  anosImssArray: string[] = [];
  maxImss: any;
  minImss: any;
  myDate;

  constructor(public formBuilder: FormBuilder) {
    moment.locale("es");
    moment.locale("ES");
  }

  datex(date: string) {
    return moment(date);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.validation = changes && changes.validation && changes.validation.currentValue ? changes.validation.currentValue : this.validation;
    this.ocupation = changes && changes.ocupation && changes.ocupation.currentValue ? changes.ocupation.currentValue : this.ocupation;
    this.fullName = changes && changes.fullName && changes.fullName.currentValue ? changes.fullName.currentValue : this.fullName;
    if (this.fullName) {
      if (this.myForm && this.myForm.get('name')) {
        this.myForm.get('name').setValue(this.fullName);
        this.updateData();
      }
    }


    if (this.ocupation.toLowerCase() === 'director' || this.ocupation.toLowerCase() === 'gerente') {

      //}
      // if (this.ocupation === 'Director' || this.ocupation === 'director' || this.ocupation === 'Gerente' || this.ocupation === 'gerente') {
      if (this.myForm && this.myForm.get('ocupation')) {
        this.myForm.get('ocupation').setValue(String(this.ocupation).toLowerCase());
        this.updateData();
      }
    }
  }

  ngOnInit() {
    this.SbmMin = this.sbmMin ? this.sbmMin : 0;
    this.SbmMax = this.sbmMax ? this.sbmMax : 0;
    this.myForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      ocupation: ['gerente', [Validators.required]],
      age: [50, [Validators.required]],
      ageTarget: [65, [Validators.required]],
      seniority: [20, [Validators.required]],
      immssEntry: ["1995-06", [Validators.required]],
      salaryGreaterThan: [true, [Validators.required]],
      retirementSaving: [true, [Validators.required]],
      corporateRetirementPlan: [true, [Validators.required]],
      //OCULTOS
      salary: [this.SbmMin],
      monthlySavings: [1],
      match: [2.5],
      yearsSaving: [0],
      compensationTimes: [1],
      initialBalanceDerivedFromThePreviousPlan: [50000],
      salaryToConsider: [150000],
      integralSalary: [180000]
    });
    if (this.data) {
      this.myForm.setValue({
        name: this.data && this.data.name ? this.data.name : '',
        ocupation: this.data && this.data.ocupation ? this.data.ocupation : 'gerente',
        age: this.data && this.data.age ? this.data.age : 50,
        ageTarget: this.data && this.data.ageTarget ? this.data.ageTarget : 65,
        seniority: this.data && this.data.seniority ? this.data.seniority : 20,
        immssEntry: this.data && this.data.immssEntry ? this.data.immssEntry : "1995-06",
        salaryGreaterThan: this.data && this.data.salaryGreaterThan == false ? this.data.salaryGreaterThan : true,
        retirementSaving: this.data && this.data.retirementSaving == true ? this.data.retirementSaving : true,
        corporateRetirementPlan: this.data && this.data.corporateRetirementPlan == true ? this.data.corporateRetirementPlan : true,
        //OCULTOS
        salary: this.data && this.data.salary ? this.data.salary : this.SbmMin,
        monthlySavings: this.data && this.data.monthlySavings ? this.data.monthlySavings : 0,
        match: this.data && this.data.match ? this.data.match : 5,
        yearsSaving: this.data && this.data.yearsSaving ? this.data.yearsSaving : 0,
        compensationTimes: this.data && this.data.compensationTimes ? this.data.compensationTimes : 0,
        initialBalanceDerivedFromThePreviousPlan: this.data && this.data.initialBalanceDerivedFromThePreviousPlan ? this.data.initialBalanceDerivedFromThePreviousPlan : 0,
        salaryToConsider: this.data && this.data.salaryToConsider ? this.data.salaryToConsider : 0,
        integralSalary: this.data && this.data.integralSalary ? this.data.integralSalary : 0
      });
    }
    this.SbmMax = 25 * this.umaDiaria * 30;
    this.updateData();
  }

  momento(date: string) {
    return moment(date);
  }

  capitalize(s) {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  beforeUpdateData() {
    const seniority = Number(this.myForm.get('seniority').value);
    this.myForm.get('seniority').setValue(0);
    this.myForm.get('seniority').setValue(seniority);
    this.myForm.controls.seniority.markAsDirty();
    this.myForm.controls.seniority.markAsTouched();
    this.updateData();
  }

  toDate(date: any) {
    return moment(date);
  }

  updateData() {
    this.SbmMax = 25 * this.umaDiaria * 30;
    this.realTime.emit(this.myForm.value);
    ///
    this.myForm.get('age').setValidators([Validators.min(this.validation.edadActual.col1), Validators.max(this.validation.edadActual.col2)]);

    //console.log("Antiguedad: ", seniority);
    this.myForm.get('ageTarget').setValidators([Validators.min(this.validation.edadJubilacion.col1), Validators.max(this.validation.edadJubilacion.col2)]);
    this.myForm.get('seniority').setValidators([Validators.min(this.validation.antiguedad.col1), Validators.max(this.validation.antiguedad.col2)]);
    //salaryGreaterThan
    if (!this.myForm.value.salaryGreaterThan) {
      this.myForm.get('salary').setValidators([Validators.required, Validators.min(this.validation.sueldoMensual.col1), Validators.max(this.validation.sueldoMensual.col2)]);
    } else {
      this.myForm.get('salary').clearValidators();
    }
    //retirementSaving
    if (this.myForm.value.retirementSaving) {
      this.myForm.get('monthlySavings').setValidators([Validators.required, Validators.min(this.validation.ahorroIndividual.col1), Validators.max(this.validation.ahorroIndividual.col2)]);
      this.myForm.get('yearsSaving').setValidators([Validators.required]);
    } else {
      this.myForm.get('monthlySavings').clearValidators();
      this.myForm.get('yearsSaving').clearValidators();
    }
    //corporateRetirementPlan
    if (this.myForm.value.corporateRetirementPlan) {
      this.myForm.get('integralSalary').setValidators([Validators.required]);
      this.myForm.get('initialBalanceDerivedFromThePreviousPlan').setValidators([Validators.required]);
      this.myForm.get('salaryToConsider').setValidators([Validators.required, Validators.min(this.validation.limiteMininoSueldo)]);
    } else {
      this.myForm.get('integralSalary').setValidators([Validators.required]);
      this.myForm.get('initialBalanceDerivedFromThePreviousPlan').clearValidators();
      this.myForm.get('salaryToConsider').clearValidators();
    }
    ////////
    this.minImss = this.validation.anoImss.col1 < this.validation.anoImss.col2 ? this.validation.anoImss.col1 : this.validation.anoImss.col2;
    this.maxImss = this.validation.anoImss.col2 > this.validation.anoImss.col1 ? this.validation.anoImss.col2 : this.validation.anoImss.col1;
    this.minImss = moment(this.minImss + "-01").format("YYYY-MM");
    this.maxImss = moment(this.maxImss + "-12").format("YYYY-MM");
    // console.log("minImss:", this.minImss);
    // console.log("maxImss:", this.maxImss);
    // console.log("immssEntry:", this.myForm.get("immssEntry").value);
    ///////////
    const max = String(this.ocupation).toLowerCase() === 'director' ? 5 : 2.5;
    const myVal = Number(this.myForm.value.monthlySavings);
    let match: number = 0;
    if (myVal <= max) {
      match = myVal;
    } else {
      match = max;
    }
    this.myForm.get("match").setValue(match);
  }

  form1Change1(event) {
    if (event && event.value == true) {
      this.myForm.controls.salary.disable();
    } else {
      this.myForm.controls.salary.enable();
      this.myForm.controls.salary.setValidators([Validators.required, Validators.min(this.SbmMin), Validators.max(this.SbmMax)]);
    }
    this.updateData();
  }

  form1Change2(event) {
    if (event && event.value == true) {
      this.myForm.controls.monthlySavings.enable();
      this.myForm.controls.yearsSaving.enable();
      this.myForm.controls.monthlySavings.setValidators([Validators.required, Validators.min(0)]);
      this.myForm.controls.yearsSaving.setValidators([Validators.required, Validators.min(0)]);
    } else {
      this.myForm.controls.monthlySavings.disable();
      this.myForm.controls.yearsSaving.disable();
    }
    this.updateData();
  }

  form1Change3(event) {
    if (event && event.value == true) {
      this.myForm.controls.integralSalary.enable();
      this.myForm.controls.initialBalanceDerivedFromThePreviousPlan.enable();
      this.myForm.controls.salaryToConsider.enable();
      this.myForm.controls.integralSalary.setValidators([Validators.required, Validators.min(1)]);
      this.myForm.controls.initialBalanceDerivedFromThePreviousPlan.setValidators([Validators.required, Validators.min(1)]);
      this.myForm.controls.salaryToConsider.setValidators([Validators.required, Validators.min(1)]);
    } else {
      this.myForm.controls.integralSalary.disable();
      this.myForm.controls.initialBalanceDerivedFromThePreviousPlan.disable();
      this.myForm.controls.salaryToConsider.disable();
    }
    this.updateData();
  }

  submit() {
    this.SbmMax = 25 * this.umaDiaria * 30;
    this.dataReturn.emit(this.myForm.value);
  }

  back(): void {
    this.formBack.emit();
  }

}


// WEBPACK FOOTER //
// ./src/components/retirement-tools/retirement-calculator/perfil/perfil.ts